var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCanceled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#FF0000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.86237 8.31952C9.43633 7.89349 8.74556 7.89349 8.31953 8.31952C7.89349 8.74554 7.89349 9.43627 8.31953 9.8623L10.4573 12L8.31953 14.1377C7.89364 14.5637 7.89364 15.2545 8.31953 15.6805C8.74556 16.1065 9.43633 16.1065 9.86237 15.6805L12.0001 13.5428L14.1377 15.6805C14.5638 16.1065 15.2545 16.1065 15.6806 15.6805C16.1066 15.2544 16.1066 14.5637 15.6806 14.1377L13.5428 12L15.6806 9.86233C16.1066 9.43629 16.1066 8.74557 15.6806 8.31955C15.2545 7.89351 14.5638 7.89351 14.1377 8.31955L12.0001 10.4572L9.86237 8.31952Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanceled);
export default __webpack_public_path__ + "static/media/Canceled.a723531e14e8f82e9c6dfed76679996c.svg";
export { ForwardRef as ReactComponent };